import React, {Component} from "react";
import Chart from "react-apexcharts";
import moment from 'moment/moment';
import firebase from 'firebase';


function getWN(minus) {
    return moment().subtract(minus *7,'days').format('w');
}

var _data = [
    {
        P1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    {
        P2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    {
        P3: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    {
        P4: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    }
];
const DevStore = {
    listeners: [],

    get data() {
        return _data;
    },
    set data(val) {
        //console.log("authorization : Basic "+val);
        fetch('https://us-central1-lumdash.cloudfunctions.net/chart',{
            //fetch('http://localhost:8010/lumapps-dashboard/us-central1/chart',{
            method: 'GET',
            mode: 'cors',
            headers: {
                'Access-Control-Allow-Origin':'*',
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':'Basic '+ val
            }
        })
            .then(response => {
                //console.log('Response : '+ response.status + ' ' + response.statusText);
                if(response.ok) {
                    //console.log(response.json());
                    return response.json()
                }
                else{
                    return _data;
                }
            })
            .then(data => {
                var i = 0;
                for(var elements in data){
                    _data[0].P1[11-i] = data[elements].nbP1;
                    _data[1].P2[11-i] = data[elements].nbP2;
                    _data[2].P3[11-i] = data[elements].nbP3;
                    _data[3].P4[11-i] = data[elements].nbP4;
                    i++;
                }

                //_data = data;
            })
            .then(()=>{
                this.notify();
            });
    },
    listen(handler) {
        this.listeners.push(handler);
    },
    remove(handler) {
        this.listeners = this.listeners.filter(x => x !== handler);
    },
    notify() {
        this.listeners.forEach(f => f());
    }
};


class PriorityChart extends Component {

    constructor(props){
        super(props);
        this.state = {
            options: {
                chart: {
                    stacked: true,
                    toolbar: {
                        show: false
                    },
                    foreColor: '#FFFFFF'
                },
                title:{
                    text: 'Opened Issues by weeks',
                    align: 'left',
                    style: {
                        color: '#FFFFFF',
                        fontSize: '24px'
                    }
                },
                colors: ['#FD2E18', '#FDAA18', '#339933', '#6666ff'],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                plotOptions: {
                    bar: {
                        horizontal: false,
                    },
                },

                xaxis: {
                    categories: [getWN(11),getWN(10),getWN(9),getWN(8),getWN(7),
                        getWN(6),getWN(5),getWN(4),getWN(3),getWN(2),
                        getWN(1),getWN(0)],
                    title: {
                        text: 'weeks'
                    },
                    labels:{
                        style:{
                            color: '#FFFFFF'
                        }
                    }

                },
                yaxis: {
                    title: {
                        text: 'Nb Issues'
                    },
                    min: 0,
                    max: 50
                },
                legend: {
                    position: 'right',
                    offsetY: 40
                },
                fill: {
                    opacity: 1
                }
            },
            series: [
                {
                    name: "P1",
                    data: _data[0].P1
                },
                {
                    name: "P2",
                    data: _data[1].P2
                },
                {
                    name: "P3",
                    data: _data[2].P3
                },
                {
                    name: "P4",
                    data: _data[3].P4
                }
            ]

        }
        //First Fetch
        firebase.auth().currentUser.getIdToken(true).then(function(idToken){
            //console.log(idToken);
            DevStore.data = idToken;
        });

    }

    update = () => {
        this.setState({series: DevStore.data });
    }

    componentDidMount(){
        setInterval(function(){


            //console.log("update Launch");
            firebase.auth().currentUser.getIdToken(true).then(function(idToken){
                DevStore.data = idToken;
            });
            //DataStore.data = self.props.anUser;
        },1000*60*5);

        DevStore.listen(this.update);

    }

    render() {

        return (

            <div>
                <Chart options={this.state.options} series={this.state.series} type="bar" height="450" width="850" />
            </div>

        );


    }
}

export default PriorityChart;





// WEBPACK FOOTER //
// ./src/components/Graphs/graphOpened.js